import {showDialog, showSnackbar} from '@dvrd/dvr-controls';
import {ResponseData} from '@dvrd/fetch';
import React, {useContext} from 'react';
import {ContentMode, Language} from '../../../util/enums';
import {logout, publishContent} from '../../../util/requestSender';
import {createErrorMessage} from '../../../util/utils';
import {AppContext} from '../../context/appContext';
import {ContentContext} from '../../context/contentContext';
import AdminHeader from './adminHeader';
import {useNavigate} from 'react-router';
import {ADMIN_DOCUMENTS_ROUTE} from "../../../util/constants";

export default function AdminHeaderController() {
    const {language, contentMode, onChangeContext} = useContext(ContentContext);
    const appContext = useContext(AppContext);
    const navigate = useNavigate();
    if (!appContext.userContext.user) return null;

    function onNavigateAdmin() {
        navigate(ADMIN_DOCUMENTS_ROUTE);
    }

    function onToggleMode() {
        const nextMode = contentMode === ContentMode.LIVE ? ContentMode.PREVIEW : ContentMode.LIVE;
        onChangeContext({contentMode: nextMode});
    }

    function onClickLogout() {
        logout({
            callback: (data: ResponseData) => {
                if (data.success) {
                    appContext.onChangeContext({user: null});
                    showSnackbar('Je bent uitgelogd');
                } else showDialog(createErrorMessage(data.message ?? 'Het uitloggen is niet gelukt.'),
                    'Uitloggen mislukt');
            }
        });
    }

    function onClickPublish() {
        const currentLanguage = language === Language.NL ? 'Nederlands' : 'Engels';
        showDialog(`Wil je alleen ${currentLanguage} of beide talen publiceren?`, 'Website publiceren',
            [{label: `Alleen ${currentLanguage} publiceren`, onClick: onConfirmPublish(language), primary: false},
                {label: 'Beide talen publiceren', onClick: onConfirmPublish('all'), primary: false}]);
    }

    function onConfirmPublish(language: Language | 'all') {
        return function() {
            publishContent({
                data: {language}, callback: (data: ResponseData) => {
                    if (data.success) showSnackbar('De website is gepubliceerd');
                    else showDialog(createErrorMessage(data.message ?? 'Het publiceren van de website is niet gelukt.'),
                        'Publiceren mislukt');
                }
            });
        };
    }

    return (
        <AdminHeader onToggleMode={onToggleMode} onClickLogout={onClickLogout} onClickPublish={onClickPublish}
                     onNavigateAdmin={onNavigateAdmin}/>
    );
}

AdminHeaderController.displayName = 'AdminHeaderController';